export const WAIT_TOLERANCE_MINUTES = 16;
export const FULL_SCORE_WAIT_EXCESS_MINUTES = 5;
export const ZERO_SCORE_WAIT_EXCESS_MINUTES = 25;
export const NO_WAIT_MARKS_LABEL = "—";
export const MAX_PLAUSIBLE_WAIT_HOURS = 6;
export const DEPARTURE_CUTOFF_LABEL = "5 am";
export const LEVEL_EXCESS_CAP_MINUTES = ZERO_SCORE_WAIT_EXCESS_MINUTES;
export const PEER_WAIT_MARGIN_MINUTES = 10;
export const KITCHEN_LATE_ROUTE_MIN_DAYS = 3;
export const KITCHEN_LATE_ROUTE_MIN_DEALERS = 2;
export const LEVEL_CUT_LENGTH_DAYS = 14;
export const ON_TIME_LABEL = "A tiempo";
export const DELAYED_LABEL = "Con demora";
export const NOT_COUNTED_LABEL = "No cuenta";
